"use client";
import "./index.css";

const ProfileInfo = ({ user, onEditProfile, onLogout }) => {
  if(!user) return null;
  const { fullName, createdAt, email, dob, phone, userImage } = user;
  return (
    <div className="pc-container">
      <div className="pc-header">
        <div className="pc-edit-button-container">
      <button className="pc-edit-button" onClick={onEditProfile}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
              <path d="m15 5 4 4" />
            </svg>
          </button>
        </div>
        <div className="pc-header-content">
          <div className="pc-avatar">
            <img src={userImage || "/placeholder.svg?height=96&width=96"} alt="Sarah Johnson" className="pc-avatar-image" />
          </div>
          <h3 className="pc-name">{fullName || 'N/A'}</h3>
          <p className="pc-description">
            Premium Member since {createdAt ? new Date(createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }) : 'N/A'}
          </p>
        </div>
      </div>
      <div className="pc-content">
        <div className="pc-info-items">
          <ProfileInfoItem icon={<UserIcon />} label="Email" value={email || 'N/A'} />
          <ProfileInfoItem icon={<BellIcon />} label="Phone" value={phone || 'N/A'} />
          <ProfileInfoItem
            icon={<PackageIcon />}
            label="Birthday 🎂"
            value={dob ? new Date(dob).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }) : 'August 15, 1995'}
            note="Special birthday treat coming soon!"
          />
          <ProfileInfoItem 
            icon={<LogoutIcon />} 
            label="Account" 
            value={<button onClick={onLogout} style={{border:"none", color: "#581c87",fontWeight: "500", backgroundColor:"transparent"}} className="pc-logout-button">Logout</button>} 
          />
        </div>
      </div>
    </div>
  );
};

const ProfileInfoItem = ({ icon, label, value, note }) => {
  return (
    <div className="pc-info-item">
      <div className="pc-info-icon">{icon}</div>
      <div>
        <p className="pc-info-label">{label}</p>
        <div className="pc-info-value">{value}</div>
        {note && <p className="pc-birthday-note">{note}</p>}
      </div>
    </div>
  );
};

const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const BellIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </svg>
);

const PackageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 10V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6" />
    <circle cx="9" cy="9" r="2" />
    <path d="m15 9-2 2-4-4-4 4v6h16v-6l-2-2-2 2-2-2" />
  </svg>
);

const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export default ProfileInfo;